export const formatToOneDecimal = (value: number | null | undefined): string => {
    if (value == null) return "N/A"; // Handle null or undefined values
    return Number(value).toFixed(1);
};
